import update from 'immutability-helper';
import { env_url } from './endpoints';
import {
	formatStat,
	formatGameTeamDetails,
	getPlayerLink,
	getPlayerLinkWithNumberAndPosition,
	formatDivisionRanksNumericValue,
	getPlayerImageURL,
	formatPlayerLink,
	sortByPlayerElement,
	sortByNumber,
	getTeamLogoUrlFromTeamName,
} from './shared_helpers';
import React from 'react';
import { preserveQueryParams } from './browser_helpers';

export const MLBsilhouette = `${env_url}/player-silhouette-baseball-cut.png`;

export const formatPitcherMatchupStats = stats => {
	const variableStats = {};
	let permKeys = [];

	const vStatsKeys = !stats.is_season_stat ? ['walks', 'strike_outs'] : [];
	const pStatsKeys = !stats.is_season_stat
		? ['innings_pitched', 'hits', 'earned_runs']
		: ['earned_run_average', 'record'];

	vStatsKeys.map(stat => {
		return stats[stat] !== 0 ? (variableStats[stat] = stats[stat]) : null;
	});

	pStatsKeys.map(stat => {
		if (stat === 'earned_run_average') {
			return stats[stat] !== '-' ? permKeys.push(stat) : null;
		}
		return stats[stat] !== 0 ? permKeys.push(stat) : null;
	});

	const keysSorted = Object.keys(variableStats).sort(function(a, b) {
		return variableStats[b] - variableStats[a];
	});
	const mergedOrder = permKeys.concat(keysSorted);

	const formatOrder = mergedOrder
		.map(statkey => {
			switch (statkey) {
				case 'hits':
					return ` ${stats.hits} H`;
				case 'innings_pitched':
					return `${stats.innings_pitched} IP`;
				case 'earned_runs':
					return ` ${stats.earned_runs} ER`;
				case 'walks':
					return ` ${stats.walks} BB`;
				case 'strike_outs':
					return ` ${stats.strike_outs} K`;
				case 'record':
					return ` ${stats.wins}-${stats.losses}`;
				case 'earned_run_average':
					return ` ${stats.earned_run_average}`;
				default:
					return '';
			}
		})
		.slice(0, 4);

	return `${formatOrder}`;
};

export const formatBatterMatchupStats = stats => {
	const variableStats = {};
	let permKeys = [];

	const vStatsKeys = !stats.is_season_stat
		? ['doubles', 'runs_batted_in', 'hit_by_pitch', 'sacrifice_flies', 'stolen_bases', 'strike_outs', 'walks']
		: [];
	const pStatsKeys = !stats.is_season_stat
		? ['at_bats', 'home_runs', 'triples']
		: ['batting_average', 'home_runs', 'runs_batted_in'];

	vStatsKeys.map(stat => {
		return stats[stat] !== 0 ? (variableStats[stat] = stats[stat]) : '0';
	});
	pStatsKeys.map(stat => {
		return stats[stat] !== 0 || stat === 'at_bats' ? permKeys.push(stat) : '0';
	});

	const keysSorted = Object.keys(variableStats).sort(function(a, b) {
		return variableStats[b] - variableStats[a];
	});
	const mergedOrder = permKeys.concat(keysSorted);

	const formatOrder = mergedOrder
		.map(statkey => {
			switch (statkey) {
				case 'doubles':
					return stats.doubles !== 1 ? ` ${stats.doubles} 2B` : ` 2B`;
				case 'triples':
					return stats.triples !== 1 ? ` ${stats.triples} 3B` : ` 3B`;
				case 'runs_batted_in':
					return ` ${stats.runs_batted_in} RBI`;
				case 'walks':
					return ` ${stats.walks} BB`;
				case 'strike_outs':
					return ` ${stats.strike_outs} K`;
				case 'home_runs':
					return stats.home_runs !== 1 ? ` ${stats.home_runs} HR` : ` HR`;
				case 'stolen_bases':
					return stats.stolen_bases !== 1 ? ` ${stats.stolen_bases} SB` : ` SB`;
				case 'at_bats':
					return stats.at_bats !== 0 ? ` ${stats.hits}-${stats.at_bats}` : '0-0';
				case 'batting_average':
					return stats.batting_average !== '-' ? ` ${stats.batting_average}` : '.000';
				case 'hit_by_pitch':
					return stats.hit_by_pitch !== 1 ? ` ${stats.hit_by_pitch} HBP` : ' HBP';
				case 'sacrifice_flies':
					return stats.sacrifice_flies !== 1 ? ` ${stats.sacrifice_flies} SAC` : ' SAC';
				default:
					return '';
			}
		})
		.slice(0, 4);

	return `${formatOrder}`;
};

export const imgErrMLB = ev => {
	ev.target.src = MLBsilhouette;
};

export const inning_pbp_format = data => {
	const removeEv = [2, 3];
	const red_events = [
		16,
		18,
		19,
		31,
		32,
		33,
		34,
		35,
		36,
		37,
		38,
		41,
		43,
		44,
		45,
		46,
		47,
		48,
		49,
		50,
		51,
		52,
		53,
		61,
		62,
		63,
		64,
		65,
		66,
		67,
		68,
		69,
		72,
		73,
		74,
		75,
		76,
		77,
		'kFT',
		'kKL',
		'kKS',
		'oFO',
		'oGO',
		'oLO',
		'oPO',
		'oSB',
		'oSF',
	];
	const blue_events = [
		4,
		6,
		7,
		8,
		10,
		11,
		12,
		13,
		14,
		15,
		17,
		20,
		21,
		22,
		23,
		24,
		25,
		26,
		27,
		28,
		29,
		30,
		54,
		55,
		56,
		60,
		'aD',
		'aDAD3',
		'aDAD4',
		'aHR',
		'aHBP',
		'aIBB',
		'aS',
		'aSAD2',
		'aSAD3',
		'aSAD4',
		'aT',
		'aTAD4',
		'bB',
		'aROE',
		'aROEAD2',
		'aROEAD3',
		'aROEAD4',
		'aBK',
		'oFC',
	];

	let new_pbp_arr = [];
	const cleaned = data.filter(function(play) {
		return removeEv.indexOf(play.event_id) === -1;
	});

	cleaned.map((play, i) => {
		let merge_play = {};
		// Add color to play obj //
		if (red_events.indexOf(+play.event_id) > -1 || red_events.includes(play.play_type)) {
			merge_play.color = 'red';
			merge_play.game_event = true;
		} else if (blue_events.indexOf(+play.event_id) > -1 || blue_events.includes(play.play_type)) {
			merge_play.color = 'blue';
			merge_play.game_event = true;
		} else {
			merge_play.color = 'no_color';
			merge_play.game_event = false;
		}

		return new_pbp_arr.push(update(merge_play, { $merge: data[i] }));
	});

	return new_pbp_arr;
};

/*
 * isPlayoffGame: Check if game is a playoffs game
 * @param {string} gametype - type of a game played
 * @return {boolean} - is game a playoff game
 */
export const isPlayoffGame = gametype => {
	switch (gametype) {
		case 'Wild Card Game':
		case 'Division Playoff':
		case 'LCS':
		case 'World Series':
			return true;
		default:
			return false;
	}
};

/*
 * seriesGames: How many game in particular playoff series
 * @param {string} gametype - type of a game played
 * @return {int} - number of games in a series
 */
export const seriesGames = gametype => {
	switch (gametype) {
		case 'Division Playoff':
			return 5;
		case 'LCS':
		case 'World Series':
			return 7;
		default:
			return 1;
	}
};

export const mlbTeamNameIDArrayMap = new Map([
	['25507be1-6a68-4267-bd82-e097d94b359b', 'arizona-diamondbacks'],
	['12079497-e414-450a-8bf2-29f91de646bf', 'atlanta-braves'],
	['75729d34-bca7-4a0f-b3df-6f26c6ad3719', 'baltimore-orioles'],
	['93941372-eb4c-4c40-aced-fe3267174393', 'boston-red-sox'],
	['55714da8-fcaf-4574-8443-59bfb511a524', 'chicago-cubs'],
	['47f490cd-2f58-4ef7-9dfd-2ad6ba6c1ae8', 'chicago-white-sox'],
	['c874a065-c115-4e7d-b0f0-235584fb0e6f', 'cincinnati-reds'],
	['80715d0d-0d2a-450f-a970-1b9a3b18c7e7', 'cleveland-guardians'],
	['29dd9a87-5bcc-4774-80c3-7f50d985068b', 'colorado-rockies'],
	['575c19b7-4052-41c2-9f0a-1c5813d02f99', 'detroit-tigers'],
	['eb21dadd-8f10-4095-8bf3-dfb3b779f107', 'houston-astros'],
	['833a51a9-0d84-410f-bd77-da08c3e5e26e', 'kansas-city-royals'],
	['4f735188-37c8-473d-ae32-1f7e34ccf892', 'los-angeles-angels'],
	['ef64da7f-cfaf-4300-87b0-9313386b977c', 'los-angeles-dodgers'],
	['03556285-bdbb-4576-a06d-42f71f46ddc5', 'miami-marlins'],
	['dcfd5266-00ce-442c-bc09-264cd20cf455', 'milwaukee-brewers'],
	['aa34e0ed-f342-4ec6-b774-c79b47b60e2d', 'minnesota-twins'],
	['f246a5e5-afdb-479c-9aaa-c68beeda7af6', 'new-york-mets'],
	['a09ec676-f887-43dc-bbb3-cf4bbaee9a18', 'new-york-yankees'],
	['27a59d3b-ff7c-48ea-b016-4798f560f5e1', 'oakland-athletics'],
	['2142e1ba-3b40-445c-b8bb-f1f8b1054220', 'philadelphia-phillies'],
	['481dfe7e-5dab-46ab-a49f-9dcc2b6e2cfd', 'pittsburgh-pirates'],
	['d52d5339-cbdd-43f3-9dfa-a42fd588b9a3', 'san-diego-padres'],
	['a7723160-10b7-4277-a309-d8dd95a8ae65', 'san-francisco-giants'],
	['43a39081-52b4-4f93-ad29-da7f329ea960', 'seattle-mariners'],
	['44671792-dc02-4fdd-a5ad-f5f17edaa9d7', 'st-louis-cardinals'],
	['bdc11650-6f74-49c4-875e-778aeb7632d9', 'tampa-bay-rays'],
	['d99f919b-1534-4516-8e8a-9cd106c6d8cd', 'texas-rangers'],
	['1d678440-b4b1-4954-9b39-70afb3ebbcfa', 'toronto-blue-jays'],
	['d89bed32-3aee-4407-99e3-4103641b999a', 'washington-nationals'],
]);

export function formatHittersTable(team = {}) {
	const { batters = [] } = team;
	let atBatsSum = 0,
		runsSum = 0,
		hitsSum = 0,
		runsBattedInSum = 0,
		homeRunsSum = 0,
		walksSum = 0,
		strikeOutsSum = 0;

	const tableData = batters.map(player => {
		const isSubstitution = !player.started_game;
		if (!player.is_season_stat) {
			atBatsSum = atBatsSum + player.at_bats;
			runsSum = runsSum + player.runs;
			hitsSum = hitsSum + player.hits;
			runsBattedInSum = runsBattedInSum + player.runs_batted_in;
			homeRunsSum = homeRunsSum + player.home_runs;
			walksSum = walksSum + player.walks;
			strikeOutsSum = strikeOutsSum + player.strike_outs;

			return {
				name: getPlayerLinkWithNumberAndPosition(player, isSubstitution),
				atBats: player.at_bats,
				runs: player.runs,
				hits: player.hits,
				runsBattedIn: player.runs_batted_in,
				homeRuns: player.home_runs,
				walks: player.walks,
				strikeOuts: player.strike_outs,
				battingAverage: player.batting_average,
			};
		} else {
			return {
				name: getPlayerLinkWithNumberAndPosition(player, isSubstitution),
				atBats: 0,
				runs: 0,
				hits: 0,
				runsBattedIn: 0,
				homeRuns: 0,
				walks: 0,
				strikeOuts: 0,
				battingAverage: player.batting_average,
			};
		}
	});

	const totals = [
		{
			name: boldTextComponent('Totals'),
			atBats: boldTextComponent(atBatsSum),
			runs: boldTextComponent(runsSum),
			hits: boldTextComponent(hitsSum),
			runsBattedIn: boldTextComponent(runsBattedInSum),
			homeRuns: boldTextComponent(homeRunsSum),
			walks: boldTextComponent(walksSum),
			strikeOuts: boldTextComponent(strikeOutsSum),
			battingAverage: <></>,
		},
	];

	return [
		{
			title: 'HITTERS',
			columns: [
				{ title: 'AB', dataKey: 'atBats', tooltipText: 'At-Bats' },
				{ title: 'R', dataKey: 'runs', tooltipText: 'Runs' },
				{ title: 'H', dataKey: 'hits', tooltipText: 'Hits' },
				{ title: 'RBI', dataKey: 'runsBattedIn', tooltipText: 'Runs Batted In' },
				{ title: 'HR', dataKey: 'homeRuns', tooltipText: 'Home Runs' },
				{ title: 'BB', dataKey: 'walks', tooltipText: 'Walks' },
				{ title: 'SO', dataKey: 'strikeOuts', tooltipText: 'Strikeouts' },
				{ title: 'AVG', dataKey: 'battingAverage', tooltipText: 'Batting Average' },
			],
			data: tableData,
			totals: totals,
		},
	];
}

export function formatPitchersTable(team = {}) {
	let inningsPitchedSum = 0,
		hitsSum = 0,
		runsSum = 0,
		earnedRunsSum = 0,
		walksSum = 0,
		strikeOutsSum = 0,
		homeRunsAllowedSum = 0;

	const { pitchers = [] } = team;

	const tableData = pitchers.map(player => {
		if (!player.is_season_stat) {
			inningsPitchedSum = sumInningsPitched(inningsPitchedSum, Number(player.innings_pitched));
			runsSum = runsSum + Number(player.runs);
			hitsSum = hitsSum + Number(player.hits);
			earnedRunsSum = earnedRunsSum + Number(player.earned_runs);
			walksSum = walksSum + Number(player.walks);
			strikeOutsSum = strikeOutsSum + Number(player.strike_outs);
			homeRunsAllowedSum = homeRunsAllowedSum + Number(player.home_runs_allowed);

			return {
				name: getPlayerLinkWithNumberAndPosition(player),
				inningsPitched: player.innings_pitched,
				hits: player.hits,
				runs: player.runs,
				earnedRuns: player.earned_runs,
				walks: player.walks,
				strikeOuts: player.strike_outs,
				earnedRunAverage: player.earned_run_average,
			};
		} else {
			return {
				name: getPlayerLinkWithNumberAndPosition(player),
				inningsPitched: '0.0',
				hits: 0,
				runs: 0,
				earnedRuns: 0,
				walks: 0,
				strikeOuts: 0,
				earnedRunAverage: player.earned_run_average,
			};
		}
	});
	const totals = [
		{
			name: boldTextComponent('Totals'),
			inningsPitched: boldTextComponent(inningsPitchedSum.toFixed(1)),
			runs: boldTextComponent(runsSum),
			hits: boldTextComponent(hitsSum),
			earnedRuns: boldTextComponent(earnedRunsSum),
			walks: boldTextComponent(walksSum),
			strikeOuts: boldTextComponent(strikeOutsSum),
			earnedRunAverage: <></>,
		},
	];
	return [
		{
			title: 'PITCHERS',
			columns: [
				{ title: 'IP', dataKey: 'inningsPitched', tooltipText: 'Innings Pitched' },
				{ title: 'H', dataKey: 'hits', tooltipText: 'Hits Allowed' },
				{ title: 'R', dataKey: 'runs', tooltipText: 'Runs Allowed' },
				{ title: 'ER', dataKey: 'earnedRuns', tooltipText: 'Earned Runs' },
				{ title: 'BB', dataKey: 'walks', tooltipText: 'Walks Surrendered' },
				{ title: 'K', dataKey: 'strikeOuts', tooltipText: 'Strikeouts Recorded' },
				{ title: 'ERA', dataKey: 'earnedRunAverage', tooltipText: 'Earned Run Average' },
				{},
			],
			data: tableData,
			totals: totals,
		},
	];
}

export function getLegendData() {
	return [
		{
			title: 'HITTERS',
			columns: [
				{ title: 'AB', dataKey: 'atBats', tooltipText: 'At-Bats' },
				{ title: 'R', dataKey: 'runs', tooltipText: 'Runs' },
				{ title: 'H', dataKey: 'hits', tooltipText: 'Hits' },
				{ title: 'RBI', dataKey: 'runsBattedIn', tooltipText: 'Runs Batted In' },
				{ title: 'HR', dataKey: 'homeRuns', tooltipText: 'Home Runs' },
				{ title: 'BB', dataKey: 'walks', tooltipText: 'Walks' },
				{ title: 'SO', dataKey: 'strikeOuts', tooltipText: 'Strikeouts' },
				{ title: 'AVG', dataKey: 'battingAverage', tooltipText: 'Batting Average' },
			],
			data: [],
		},
		{
			title: 'PITCHERS',
			columns: [
				{ title: 'IP', dataKey: 'inningsPitched', tooltipText: 'Innings Pitched' },
				{ title: 'H', dataKey: 'hits', tooltipText: 'Hits Allowed' },
				{ title: 'R', dataKey: 'runs', tooltipText: 'Runs Allowed' },
				{ title: 'ER', dataKey: 'earnedRuns', tooltipText: 'Earned Runs' },
				{ title: 'BB', dataKey: 'walks', tooltipText: 'Walks Surrendered' },
				{ title: 'K', dataKey: 'strikeOuts', tooltipText: 'Strikeouts Recorded' },
				{ title: 'ERA', dataKey: 'earnedRunAverage', tooltipText: 'Earned Run Average' },
			],
			data: [],
		},
	];
}
function boldTextComponent(text) {
	return (
		<div
			style={{
				fontWeight: 'bold',
			}}
		>
			{text}
		</div>
	);
}

function sumInningsPitched(currentSum = Number(0), valueToAdd = Number(0)) {
	const splitCurrentSum = currentSum.toString().split('.');
	const splitValueToAdd = valueToAdd.toString().split('.');
	const currentWholeInning = Number(splitCurrentSum[0]);
	const currentPartialInning = splitCurrentSum.length > 1 ? Number(splitCurrentSum[1]) : Number(0);
	const wholeInningToAdd = Number(splitValueToAdd[0]);
	const partialInningToAdd = splitValueToAdd.length > 1 ? Number(splitValueToAdd[1]) : Number(0);

	let newWholeInning = currentWholeInning + wholeInningToAdd;
	let newPartialInning = currentPartialInning + partialInningToAdd;

	if (newPartialInning >= 3) {
		newWholeInning += 1;
		newPartialInning -= 3;
	}

	return newWholeInning + Number(`0.${newPartialInning}`);
}

export function formatInjuries(teamInjuries = []) {
	if (!teamInjuries) return [];
	const formattedInjuries = teamInjuries.map(injury => {
		return {
			playerName: getPlayerLink(injury),
			playerPosition: injury.position,
			type: injury.type ? `${injury.type.charAt(0).toUpperCase()}${injury.type.slice(1)}` : '',
			status: injury.status,
			timestamp: injury.timestamp,
			emptyColumn: ' ',
		};
	});

	return formattedInjuries.sort((a, b) => b.timestamp - a.timestamp);
}
export function formatKeyValueData(data, stats) {
	{
		var formatedObj = [];
		stats.map(stat => {
			let value = data[stat.key] ? data[stat.key] : '';
			if (Array.isArray(value)) {
				value = value.join(', ');
			}
			if (value !== '') formatedObj.push({ key: stat.label, value: value });
		});
		return formatedObj;
	}
}

export function formatTeamStats(homeTeam, visitingTeam) {
	if (!visitingTeam.season_stats || !homeTeam.season_stats) {
		return [];
	}
	const statCategories = [
		{
			title: 'Runs Per Game',
			valueKey: 'runs_per_game',
			valueFormatter: n => formatStat(n, 2),
		},
		{
			title: 'Batting Average',
			valueFormatter: n => formatStat(n, 3, false),
			valueKey: 'team_batting_average',
		},
		{
			title: 'Home Runs',
			valueKey: 'home_runs',
		},
		{
			title: 'Earned Run Average',
			valueFormatter: n => formatStat(n, 2),
			valueKey: 'earned_run_average',
		},
	];

	const teamStats = statCategories.map(statCategory => {
		let homeTeamValue = homeTeam.season_stats[statCategory.valueKey];
		let visitingTeamValue = visitingTeam.season_stats[statCategory.valueKey];

		if ((!homeTeamValue && homeTeamValue !== 0) || (!visitingTeamValue && visitingTeamValue !== 0)) {
			return null;
		}

		return {
			title: statCategory.title,
			homeTeamValue: homeTeamValue,
			visitingTeamValue: visitingTeamValue,
			isPercent: statCategory.isPercent,
			valueFormatter: statCategory.valueFormatter,
		};
	});
	return teamStats.filter(n => n);
}

export function formatGameStats(homeTeam, visitingTeam) {
	if (!visitingTeam.game_stats || !homeTeam.game_stats) {
		return [];
	}
	const statCategories = [
		{
			title: 'Hits',
			valueKey: 'hits',
		},
		{
			title: 'Errors',
			valueKey: 'errors',
		},
		{
			title: 'Left On Base',
			valueKey: 'runners_left_on_base',
		},
		{
			title: 'Home Runs',
			valueKey: 'home_runs',
		},
		{
			title: 'Walks',
			valueKey: 'walks',
		},
		{
			title: 'Strikeouts',
			valueKey: 'strike_outs',
		},
		{
			title: 'Stolen Bases',
			valueKey: 'steals',
		},
	];

	const gameStats = statCategories.map(statCategory => {
		let homeTeamValue = homeTeam.game_stats[statCategory.valueKey];
		let visitingTeamValue = visitingTeam.game_stats[statCategory.valueKey];

		if ((!homeTeamValue && homeTeamValue !== 0) || (!visitingTeamValue && visitingTeamValue !== 0)) {
			return null;
		}

		return {
			title: statCategory.title,
			homeTeamValue: homeTeamValue,
			visitingTeamValue: visitingTeamValue,
		};
	});
	return gameStats.filter(n => n);
}

export function formatGamecardData(game = {}, options = {}) {
	const gameStatus = game.game_status;

	const {
		visitingTeamName,
		visitingTeamLogo,
		homeTeamName,
		homeTeamLogo,
		broadcastName,
		broadcastString,
		gameLoser,
		gameTime,
		gameDate,
	} = formatGameTeamDetails(game);

	const matchupResult = game.series_matchups_result?.toUpperCase();

	const commonProps = {
		visitingTeamName,
		visitingTeamLogo,
		homeTeamName,
		homeTeamLogo,
		link: preserveQueryParams(`${game.new_game_url}`),
	};

	if (gameStatus === 'Pre-Game' || (gameStatus === 'if-necessary' && gameTime !== 'Invalid date')) {
		return {
			...commonProps,
			visitingTeamData: game.new_visiting_odds || '\u00A0',
			homeTeamData: game.new_home_odds || '\u00A0',
			teamDataStyle: 'odds',
			footerText: matchupResult,
			renderGameStatus: () => {
				return (
					<>
						{options.showDate ? (
							<div className='game_date'>
								{gameDate}, {gameTime}
							</div>
						) : (
							<div className='game_date'>{gameTime}</div>
						)}
						{broadcastName && <div className='broadcastName'>{broadcastName}</div>}
					</>
				);
			},
		};
	}
	if (gameStatus === 'In-Progress') {
		return {
			...commonProps,
			visitingTeamData: `${game.visiting_team?.score}`,
			homeTeamData: `${game.home_team?.score}`,
			footerText: broadcastString,
			isBaseball: true,
			firstBaseOccupied: game.runner_on_first_base,
			secondBaseOccupied: game.runner_on_second_base,
			thirdBaseOccupied: game.runner_on_third_base,
			outs: game.outs,
			inningNumber: game.period,
			inningPortion: game.period_status?.substring(0, 3)?.toLowerCase(),
		};
	}
	if (gameStatus === 'Final') {
		return {
			...commonProps,
			visitingTeamData: `${game.visiting_team?.score}`,
			homeTeamData: `${game.home_team?.score}`,
			loser: gameLoser,
			footerText: matchupResult,
			renderGameStatus: () => <div>{game.new_status_long}</div>,
		};
	}

	if (gameStatus === 'if-necessary' || gameStatus === 'time-tbd') {
		return {
			...commonProps,
			visitingTeamData: '\u00A0',
			homeTeamData: '\u00A0',
			footerText: matchupResult,
			renderGameStatus: () => {
				return (
					<>
						<div>TBD</div>
					</>
				);
			},
		};
	}

	if (gameStatus === 'wdelay' || gameStatus === 'fdelay' || gameStatus === 'odelay') {
		return {
			...commonProps,
			visitingTeamData: '\u00A0',
			homeTeamData: '\u00A0',
			footerText: matchupResult,
			renderGameStatus: () => {
				return (
					<>
						<div>Delayed</div>
					</>
				);
			},
		};
	}

	// For games that are cancelled, postponed, forfeit, etc...
	return {
		...commonProps,
		visitingTeamData: '\u00A0',
		homeTeamData: '\u00A0',
		footerText: matchupResult,
		renderGameStatus: () => {
			return (
				<>
					<div>{gameStatus}</div>
				</>
			);
		},
	};
}

export function formatSeasonRecord(team) {
	if (team?.season_stats?.wins >= 0 && team?.season_stats?.losses >= 0) {
		return `${team.season_stats.wins}-${team.season_stats.losses}`;
	} else {
		return '';
	}
}

export function formatDivisionRank(team) {
	if (team.division && team.division.rank !== 0) {
		return `${formatDivisionRanksNumericValue(team.division.rank)} ${team.division.short_name}`;
	} else {
		return '';
	}
}

export function formatSeasonLeaders(homeTeam, visitingTeam) {
	const leaderCategories = [
		{
			title: 'RBI',
			categoryKey: 'runs_batted_in_leader',
			valueKey: 'total',
		},
		{
			title: 'Home Runs',
			categoryKey: 'home_run_leader',
			valueKey: 'total',
		},
		{
			title: 'Batting Average',
			categoryKey: 'batting_average_leader',
			valueKey: 'total',
		},
		{
			title: 'Wins',
			categoryKey: 'wins_leader',
			valueKey: 'total',
		},
		{
			title: 'Strikeouts',
			categoryKey: 'strikeouts_leader',
			valueKey: 'total',
		},
		{
			title: 'Saves',
			categoryKey: 'saves_leader',
			valueKey: 'total',
		},
	];
	const seasonLeaders = leaderCategories.map(leaderCategory => {
		const homeTeamData = homeTeam?.[leaderCategory.categoryKey];
		const visitingTeamData = visitingTeam?.[leaderCategory.categoryKey];

		if (!homeTeamData || !visitingTeamData) {
			return null;
		}

		let homeTeamValue = homeTeamData[leaderCategory.valueKey];
		let visitingTeamValue = visitingTeamData[leaderCategory.valueKey];

		if (leaderCategory.categoryKey === 'batting_average_leader') {
			homeTeamValue = formatStat(homeTeamValue, 3, false);
			visitingTeamValue = formatStat(visitingTeamValue, 3, false);
		}

		if (leaderCategory.alternateValueKey) {
			homeTeamValue = homeTeamValue || homeTeamData[leaderCategory.alternateValueKey];
			visitingTeamValue = visitingTeamValue || visitingTeamData[leaderCategory.alternateValueKey];
		}

		if (leaderCategory.decimalPlaces) {
			homeTeamValue = homeTeamValue.toFixed(leaderCategory.decimalPlaces);
			visitingTeamValue = visitingTeamValue.toFixed(leaderCategory.decimalPlaces);
		}

		return {
			title: leaderCategory.title,
			homeTeamShortName: homeTeam.short_name,
			homeTeamColor: homeTeam.color,
			visitingTeamColor: visitingTeam.color,
			visitingTeamShortName: visitingTeam.short_name,
			homeTeamPlayerImage: getPlayerImageURL(homeTeamData.id, 'xs'),
			visitingTeamPlayerImage: getPlayerImageURL(visitingTeamData.id, 'xs'),
			homeTeamLogo: homeTeam.image_url_90,
			visitingTeamLogo: visitingTeam.image_url_90,
			homeTeamValue: homeTeamValue,
			visitingTeamValue: visitingTeamValue,
			homeTeamPlayerName: `${
				homeTeamData.preferred_name ? homeTeamData.preferred_name.charAt(0) : homeTeamData.first_name.charAt(0)
			}. ${homeTeamData.last_name}`,
			visitingTeamPlayerName: `${
				visitingTeamData.preferred_name
					? visitingTeamData.preferred_name.charAt(0)
					: visitingTeamData.first_name.charAt(0)
			}. ${visitingTeamData.last_name}`,
			homeTeamDetails: {
				first_name: homeTeamData.first_name,
				last_name: homeTeamData.last_name,
				id: homeTeamData.id,
			},
			visitingTeamDetails: {
				first_name: visitingTeamData.first_name,
				last_name: visitingTeamData.last_name,
				id: visitingTeamData.id,
			},
		};
	});
	return seasonLeaders.filter(n => n); // filter out null values
}

export const isBlueJays = team => {
	return team.name === 'Blue Jays' || team.city === 'Toronto';
};

export const formatLineup = (batters = []) => {
	if (!batters) return [];

	return batters
		.map(batter => {
			return {
				name: getPlayerLinkWithNumberAndPosition(batter, false, batter.batting_slot),
				position: batter.short_position,
				order: batter.batting_slot,
				hits: batter.hits,
				hits_season: batter.hits_season,
				average: batter.batting_average,
				homeRuns: batter.season_home_runs,
				runsBattedIn: batter.runs_batted_in,
				runs_batted_in_season: batter.runs_batted_in_season,
			};
		})
		.sort((a, b) => a.order - b.order);
};

function formatHittingStats(stats = []) {
	const hittingColumns = [
		{
			dataKey: 'player',
			title: 'PLAYER',
			textAlign: 'left',
			cellWidthOverride: '18',
			initialSortDirection: 'asc',
			customSortFunctionAscending: (a, b) => sortByPlayerElement(a.player, b.player),
			customSortFunctionDescending: (a, b) => sortByPlayerElement(b.player, a.player),
			sticky: true,
		},
		{
			dataKey: 'gamesPlayed',
			title: 'GP',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'gamesStarted',
			title: 'GS',
			textAlign: 'center',
			cellWidthOverride: '4',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'atBats',
			title: 'AB',
			textAlign: 'center',
			cellWidthOverride: '4',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'runs',
			title: 'R',
			textAlign: 'center',
			cellWidthOverride: '4',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'hits',
			title: 'H',
			textAlign: 'center',
			cellWidthOverride: '4',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'doubles',
			title: '2B',
			textAlign: 'center',
			cellWidthOverride: '4',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'triples',
			title: '3B',
			textAlign: 'center',
			cellWidthOverride: '4',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'homeRuns',
			title: 'HR',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'runsBattedIn',
			title: 'RBI',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'stolenBases',
			title: 'SB',
			textAlign: 'center',
			cellWidthOverride: '4',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'caughtStealing',
			title: 'CS',
			textAlign: 'center',
			cellWidthOverride: '4',
			initialSortDirection: 'asc',
		},
		{
			dataKey: 'walks',
			title: 'BB',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'strikeouts',
			title: 'SO',
			textAlign: 'center',
			cellWidthOverride: '4',
			initialSortDirection: 'asc',
		},
		{
			dataKey: 'battingAverage',
			title: 'AVG',
			textAlign: 'center',
			cellWidthOverride: '6',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'onBasePercentage',
			title: 'OBP',
			textAlign: 'center',
			cellWidthOverride: '6',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'sluggingPercentage',
			title: 'SLG',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'onBasePlusSluggin',
			title: 'OPS',
			textAlign: 'center',
			cellWidthOverride: '7',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'winsAboveReplacement',
			title: 'WAR',
			textAlign: 'center',
			cellWidthOverride: '7',
			initialSortDirection: 'desc',
		},
	];

	const hittingData = stats?.map(player => {
		return {
			player: formatPlayerLink(player, { position: player.short_position }),
			gamesPlayed: player.games_played,
			gamesStarted: player.games_started,
			atBats: player.at_bats,
			runs: player.runs,
			hits: player.hits,
			doubles: player.doubles,
			triples: player.triples,
			homeRuns: player.home_runs,
			runsBattedIn: player.runs_batted_in,
			stolenBases: player.stolen_bases,
			caughtStealing: player.caught_stealing,
			walks: player.walks,
			strikeouts: player.strike_outs,
			battingAverage: formatStat(player.batting_average, 3, false),
			onBasePercentage: formatStat(player.on_base_percentage, 3, false),
			sluggingPercentage: formatStat(player.slugging_percentage, 3, false),
			onBasePlusSluggin: formatStat(player.on_base_plus_slugging, 3, false),
			winsAboveReplacement: player.wins_above_replacement,
		};
	});

	return {
		columns: hittingColumns,
		data: hittingData,
	};
}

function formatPitchingStats(stats = []) {
	const pitchingColumns = [
		{
			dataKey: 'player',
			title: 'PLAYER',
			textAlign: 'left',
			cellWidthOverride: '18',
			initialSortDirection: 'asc',
			customSortFunctionAscending: (a, b) => sortByPlayerElement(a.player, b.player),
			customSortFunctionDescending: (a, b) => sortByPlayerElement(b.player, a.player),
			sticky: true,
		},
		{
			dataKey: 'gamesPlayed',
			title: 'GP',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'gamesStarted',
			title: 'GS',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'earnedRunAverage',
			title: 'ERA',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'asc',
			customSortFunctionAscending: (a, b) => sortByNumber(a.earnedRunAverage, b.earnedRunAverage),
			customSortFunctionDescending: (a, b) => sortByNumber(b.earnedRunAverage, a.earnedRunAverage),
		},
		{
			dataKey: 'wins',
			title: 'W',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'losses',
			title: 'L',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'asc',
		},
		{
			dataKey: 'saves',
			title: 'SV',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'saveOpportunities',
			title: 'SVO',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'completeGames',
			title: 'CG',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'inningsPitched',
			title: 'IP',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'hitsAllowed',
			title: 'H',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'asc',
		},
		{
			dataKey: 'runsAllowed',
			title: 'R',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'asc',
		},
		{
			dataKey: 'earnedRuns',
			title: 'ER',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'asc',
		},
		{
			dataKey: 'walks',
			title: 'BB',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'asc',
		},
		{
			dataKey: 'strikeouts',
			title: 'SO',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'opposingBattingAverage',
			title: 'AVG',
			textAlign: 'center',
			cellWidthOverride: '5',
			initialSortDirection: 'asc',
		},
	];

	const pitchingData = stats?.map(player => {
		return {
			player: formatPlayerLink(player),
			gamesPlayed: player.games_pitched,
			gamesStarted: player.games_started,
			earnedRunAverage: formatStat(player.earned_run_average, 2, true),
			wins: player.wins,
			losses: player.losses,
			saves: player.saves,
			saveOpportunities: player.save_opportunities,
			completeGames: player.complete_games,
			inningsPitched: player.innings_pitched,
			hitsAllowed: player.hits_allowed,
			runsAllowed: player.runs_allowed,
			earnedRuns: player.earned_runs,
			walks: player.walks,
			strikeouts: player.strike_outs,
			opposingBattingAverage: formatStat(player.opponents_batting_average, 3, false),
		};
	});

	return {
		columns: pitchingColumns,
		data: pitchingData,
	};
}

function formatFieldingStats(stats = []) {
	const fieldingColumns = [
		{
			dataKey: 'player',
			title: 'PLAYER',
			textAlign: 'left',
			cellWidthOverride: '18',
			initialSortDirection: 'asc',
			customSortFunctionAscending: (a, b) => sortByPlayerElement(a.player, b.player),
			customSortFunctionDescending: (a, b) => sortByPlayerElement(b.player, a.player),
			sticky: true,
		},
		{
			dataKey: 'gamesPlayed',
			title: 'GP',
			textAlign: 'center',
			cellWidthOverride: '10',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'gamesStarted',
			title: 'GS',
			textAlign: 'center',
			cellWidthOverride: '10',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'fieldingPercentage',
			title: 'FPCT',
			textAlign: 'center',
			cellWidthOverride: '10',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'errors',
			title: 'E',
			textAlign: 'center',
			cellWidthOverride: '10',
			initialSortDirection: 'asc',
		},
		{
			dataKey: 'putouts',
			title: 'PO',
			textAlign: 'center',
			cellWidthOverride: '10',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'assists',
			title: 'A',
			textAlign: 'center',
			cellWidthOverride: '10',
			initialSortDirection: 'desc',
		},
		{
			dataKey: 'doublePlays',
			title: 'DP',
			textAlign: 'center',
			cellWidthOverride: '10',
			initialSortDirection: 'desc',
		},
	];

	const fieldingData = stats?.map(player => {
		return {
			player: formatPlayerLink(player, { position: player.short_position }),
			gamesPlayed: player.games_played,
			gamesStarted: player.games_started,
			fieldingPercentage: formatStat(player.fielding_percentage, 3, false),
			errors: player.errors,
			putouts: player.putouts,
			assists: player.assists,
			doublePlays: player.double_plays,
		};
	});

	return {
		columns: fieldingColumns,
		data: fieldingData,
	};
}

export function formatFullSeasonStats(stats) {
	return [
		{
			title: 'Hitting',
			initialSortColumn: 'runsBattedIn',
			initialSortReverse: true,
			...formatHittingStats(stats?.hitters),
		},
		{
			title: 'Pitching',
			initialSortColumn: 'earnedRunAverage',
			...formatPitchingStats(stats?.pitchers),
		},
		{
			title: 'Fielding',
			initialSortColumn: 'fieldingPercentage',
			initialSortReverse: true,
			...formatFieldingStats(stats?.fielding),
		},
	];
}

const hittingLegendItems = [
	{
		name: 'GP',
		description: 'Games Played',
	},
	{
		name: 'GS',
		description: 'Games Started',
	},
	{
		name: 'AB',
		description: 'At Bats',
	},
	{
		name: 'R',
		description: 'Runs',
	},
	{
		name: 'H',
		description: 'Hits',
	},
	{
		name: '2B',
		description: 'Doubles',
	},
	{
		name: '3B',
		description: 'Triples',
	},
	{
		name: 'HR',
		description: 'Home Runs',
	},
	{
		name: 'RBI',
		description: 'Runs Batted In',
	},
	{
		name: 'SB',
		description: 'Stolen Bases',
	},
	{
		name: 'CS',
		description: 'Caught Stealing',
	},
	{
		name: 'BB',
		description: 'Walks (Base On Balls)',
	},
	{
		name: 'SO',
		description: 'Strikeouts',
	},
	{
		name: 'AVG',
		description: 'Batting Average',
	},
	{
		name: 'OBP',
		description: 'On-Base Percentage',
	},
	{
		name: 'SLG',
		description: 'Slugging Percentage',
	},
];

const pitchingLegendItems = [
	{
		name: 'GP',
		description: 'Games Played',
	},
	{
		name: 'GS',
		description: 'Games Started',
	},
	{
		name: 'ERA',
		description: 'Earned Run Average',
	},
	{
		name: 'W',
		description: 'Wins',
	},
	{
		name: 'L',
		description: 'Losses',
	},
	{
		name: 'SV',
		description: 'Saves',
	},
	{
		name: 'SVO',
		description: 'Save Opportunities',
	},
	{
		name: 'CG',
		description: 'Complete Games',
	},
	{
		name: 'IP',
		description: 'Innings Pitched',
	},
	{
		name: 'H',
		description: 'Hits Allowed',
	},
	{
		name: 'R',
		description: 'Runs Allowed',
	},
	{
		name: 'ER',
		description: 'Earned Runs',
	},
	{
		name: 'BB',
		description: 'Walks (Base On Balls)',
	},
	{
		name: 'SO',
		description: 'Strikeouts',
	},
	{
		name: 'AVG',
		description: 'Opponent Batting Average',
	},
];

const fieldingLegendItems = [
	{
		name: 'GP',
		description: 'Games Played',
	},
	{
		name: 'GS',
		description: 'Games Started',
	},
	{
		name: 'FPCT',
		description: 'Fielding Percentage',
	},
	{
		name: 'E',
		description: 'Errors',
	},
	{
		name: 'PO',
		description: 'Putouts',
	},
	{
		name: 'A',
		description: 'Assists',
	},
	{
		name: 'DP',
		description: 'Double Plays',
	},
];

export const statsLegendSections = [
	{
		title: 'Hitting',
		items: hittingLegendItems,
	},
	{
		title: 'Pitching',
		items: pitchingLegendItems,
	},
	{
		title: 'Fielding',
		items: fieldingLegendItems,
	},
];

// SNWEB-2216: team logo urls for the player stats table
// logo filenames on the cdn don't always match a straight slug of the team name
const MLB_TEAM_LOGO_SLUG_OVERRIDES = {
	'athletics-athletics': 'athletics',
};

export const getMLBTeamLogoUrl = teamNameFormatted =>
	getTeamLogoUrlFromTeamName('baseball', 'mlb', teamNameFormatted, MLB_TEAM_LOGO_SLUG_OVERRIDES);

const createSeries = matches => {
	const gamesByRoundId = {};

	matches.forEach(match => {
		const roundId = match.round?.round_id;
		if (!roundId) return;
		gamesByRoundId[roundId] = [...(gamesByRoundId[roundId] || []), match];
	});

	const seriesByRoundId = {};
	Object.entries(gamesByRoundId).forEach(([roundId, gamesList]) => {
		// A game marked unnecessary (series already clinched) carries a stale
		// series_wins, so drive the card from the latest actually-played game by the
		// API timestamp.
		const rankedGames = gamesList
			.filter(game => game.game_status !== 'unnecessary')
			.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
		const latestGame = rankedGames[0] || gamesList[0];
		seriesByRoundId[roundId] = { ...latestGame, gamesList };
	});

	return seriesByRoundId;
};

const getChildRoundIds = round =>
	round?.round_series?.filter(roundSeries => roundSeries.type === 'child').map(roundSeries => roundSeries.id) || [];

// keep the first-round byes on the outer edges so each league's column reads bye -> series -> bye
const orderByesToCorners = entries => {
	const byes = entries.filter(entry => entry.isBye);
	if (byes.length === 0) return entries;

	const series = entries.filter(entry => !entry.isBye);
	const [topBye, ...bottomByes] = byes;
	return [topBye, ...series, ...bottomByes];
};

// A first-round bye renders a single team waiting on the division-series slot it feeds.
const toByeEntry = (childEntry, divisionSeries) => ({
	isBye: true,
	team: childEntry.home_team || childEntry.visiting_team,
	parentRoundId: divisionSeries.round.round_id,
	round: childEntry.round,
});

export const processMLBBracketData = (data = []) => {
	const seriesByRoundId = createSeries(data);
	const bracketData = {
		al_wild_card: [],
		al_division_series: [],
		al_league_championship: [],
		world_series: [],
		nl_league_championship: [],
		nl_division_series: [],
		nl_wild_card: [],
	};

	const worldSeries = Object.values(seriesByRoundId).find(series => series.round.type === 'world_series');
	if (!worldSeries) return bracketData;

	bracketData.world_series.push(worldSeries);

	// Each series lands in its own league's column, so the column key comes from
	// the entry's round.league rather than being threaded down the traversal.
	const columnKey = (series, suffix) => `${series.round.league === 'NL' ? 'nl' : 'al'}_${suffix}`;
	const getChildSeries = series =>
		getChildRoundIds(series.round)
			.map(roundId => seriesByRoundId[roundId])
			.filter(Boolean);

	// Walk finals -> first round one level at a time (same shape as WNBA's
	// linked_cup_rounds walk): each pass reads the series collected by the previous one.
	const leagueChampionshipsGames = getChildSeries(worldSeries);
	leagueChampionshipsGames.forEach(championship => {
		bracketData[columnKey(championship, 'league_championship')].push(championship);
	});

	const divisionSeriesList = leagueChampionshipsGames.flatMap(getChildSeries);
	divisionSeriesList.forEach(divisionSeries => {
		bracketData[columnKey(divisionSeries, 'division_series')].push(divisionSeries);
	});

	divisionSeriesList.forEach(divisionSeries => {
		getChildSeries(divisionSeries).forEach(childEntry => {
			const entry = childEntry.game_status === 'bye' ? toByeEntry(childEntry, divisionSeries) : childEntry;
			bracketData[columnKey(childEntry, 'wild_card')].push(entry);
		});
	});

	bracketData.al_wild_card = orderByesToCorners(bracketData.al_wild_card);
	bracketData.nl_wild_card = orderByesToCorners(bracketData.nl_wild_card);

	return bracketData;
};
